import { PeopleCountryDto } from '../people-country.dto';
import { PeopleEmployeeDto } from './people-employee.dto';

export class PeopleEmployeePersonalDetailsDto {
    id?: number;
    employeeId?: number;
    personalEmail?: string;
    personalPhoneNumber?: string;
    personalPhoneNumberCountryId?: number;
    address1?: string;
    address2?: string;
    city?: string;
    postcode?: string;
    countryId?: number;
    dateOfBirth?: Date;
    genderId?: number;
    honorificTitleId?: number;
    ppsNumber?: string;
    passOrIdNumber?: string;

    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
    country?: PeopleCountryDto;
    personalPhoneNumberCountry?: PeopleCountryDto;
}